var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#AEB0B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-goal-icon lucide-goal",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13V2l8 4-8 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.561 10.222a9 9 0 1 1-12.55-5.29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.002 9.997a5 5 0 1 0 8.9 2.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/goal.587202503af67dcf0b4a06ecf62d86e9.svg";
export { ForwardRef as ReactComponent };